export default class MapFilter {

    constructor(props={}, onlineAppNavOption=null) {
        this.onlineAppNavOption = onlineAppNavOption;

        this.name = props.name;
        this.code = props.code;
        this.slug = props.slug;
        this.experienceIds = props.experienceIds;
    }

    includesExperience(experience) {
        if (!experience) { return false }
        return this.experienceIds.includes(experience.id);
    }

    // The curated "Everything" browse view. Identified by its stable code (slug fallback for
    // robustness). Used by the reveal resolver to prefer a specific filter over Everything —
    // see plans/2026-07-27--experience-navigation-beyond-everything-filter.md.
    isEverything() {
        return this.code === 'EVERYTHING' || this.slug === 'everything';
    }

    getMapTitle() {
        if (this.onlineAppNavOption) return this.onlineAppNavOption.getMapTitle();
        return this.name;
    }

}